export var ROUTER_URL = {
  Hubspot: '/hubspot',
  Home: '/',
  Wizard: '/wizard/:basePlanId/:id?',
  Users: '/users',
  Report: '/report/:basePlanId',
  MultiSkill: '/multiskill/:basePlanId/:id',
  Organization: '/organization',
  OrganizationWizard: '/organization/wizard',
  Dashboards: '/dashboards'
};
export var REPORT_ROUTER_URL = {
  Resourcing: 'resourcing',
  Financial: 'financial',
  Annual: 'summary',
  Period: 'period',
  Daily: 'daily',
  Interval: 'interval',
  Training: 'training',
  Actual: 'actual'
};
export var ACTUAL_ROUTER_URL = {
  Settings: 'settings'
};
export var FULL_REPORT_ROUTER_URL = {
  Annual: "".concat(ROUTER_URL.Report, "/").concat(REPORT_ROUTER_URL.Resourcing, "/").concat(REPORT_ROUTER_URL.Annual),
  Period: "".concat(ROUTER_URL.Report, "/").concat(REPORT_ROUTER_URL.Resourcing, "/").concat(REPORT_ROUTER_URL.Period),
  Daily: "".concat(ROUTER_URL.Report, "/").concat(REPORT_ROUTER_URL.Resourcing, "/").concat(REPORT_ROUTER_URL.Daily),
  Interval: "".concat(ROUTER_URL.Report, "/").concat(REPORT_ROUTER_URL.Resourcing, "/").concat(REPORT_ROUTER_URL.Interval),
  Training: "".concat(ROUTER_URL.Report, "/").concat(REPORT_ROUTER_URL.Training),
  Actual: "".concat(ROUTER_URL.Report, "/").concat(REPORT_ROUTER_URL.Actual),
  ActualSettings: "".concat(ROUTER_URL.Report, "/").concat(REPORT_ROUTER_URL.Actual, "/").concat(ACTUAL_ROUTER_URL.Settings)
};
export var REPORT_TAB_PATTERN = "".concat(ROUTER_URL.Report, "/:tab");
export var REPORT_TYPE_PATTERN = "".concat(REPORT_TAB_PATTERN, "/:reportType");